$('.dropdown-taxonomy__title').click(function(){
  $(this).parent().toggleClass('dropdown-taxonomy--open');
})
